import React from 'react';
import { Card } from 'antd';
import { SkHeader, SkStatCards, SkTabsBar, SkFilterBar, SkTable } from './_primitives';

/** AuditLogsPage — header, summary stats, severity tabs, search+filters, table with expandable rows */
const AuditLogsPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={2} />
    <SkStatCards count={4} />
    <Card className="shadow-sm">
      <SkTabsBar tabs={4} />
      <SkFilterBar filters={4} withButton />
      <div className="overflow-x-auto">
        <SkTable rows={10} cols={7} inCard={false} />
      </div>
    </Card>
  </div>
);

export default AuditLogsPageLoader;
